<template>
  <div>
	<loading :active.sync="isLoading" color="#64B9B0"></loading>
	<div class="content-wrapper">
	  <div class="container-fluid">
		<!-- Breadcrumbs-->
			<ol class="breadcrumb">
				<li class="breadcrumb-item">
				<router-link to="/adm/titulares">Titulares</router-link>
				</li>
				<li class="breadcrumb-item active">Detalhes Titular</li>
			</ol>

			<div class="box_general padding_bottom">
				<div class="header_box version_2">
				<h2>
					<i class="fa fa-info-circle"></i>Informações do Titular
				</h2>
			</div>
					
				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label>Nome do Titular</label>
							<input
								type="text"
								class="form-control"
								v-model="titular.name"
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
						<label>CPF do Titular</label>
						<input
							type="text"
							class="form-control"
							v-mask="['###.###.###-##']"
							v-model="titular.cpf"
						/>
						</div>
					</div>
						
					<div class="col-md-4">
						<div class="form-group">
						<label>E-mail do Titular</label>
						<input
							type="text"
							class="form-control"
							v-model="titular.email"
						/>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-6">
						<div class="form-group">
							<label>Nome da Mae</label>
							<input
							type="text"
							class="form-control"
							v-model="titular.nome_mae"
							/>
						</div>
					</div>

					<div class="col-md-6">
						<div class="form-group">
							<label>Nome do Pai</label>
							<input
							type="text"
							class="form-control"
							v-model="titular.nome_pai"
							/>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-4">
						<div class="form-group">
							<label>Data de Nascimento</label>
							<date-picker
				v-model="titular.birth_date"
				:lang="lang"
				format="DD/MM/YYYY"
				value-type="format"
			  ></date-picker>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>CNS</label>
							<input
							type="text"
							class="form-control"
							v-model="titular.cns"
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
							<label>Parentesco</label>
							<input
							type="text"
							class="form-control"
							v-model="titular.parentesco"
							/>
						</div>
					</div>

					<div class="col-md-4">
						<div class="form-group">
						<label>RG do Titular</label>
						<input
							type="text"
							class="form-control"
							v-model="titular.rg"
						/>
						</div>
					</div>
					
					<div class="col-md-4">
						<div class="form-group">
							<label>Estado Civil</label>
							<input
								type="text"
								class="form-control"
								v-model="titular.estado_civil"
							/>
						</div>
					</div>
					<div class="col-md-4">
						<div class="form-group">
							<label>Gênero</label>
							<input
								type="text"
								class="form-control"
								v-model="titular.genero"
							/>
						</div>
					</div>
				</div>

				<div class="row">
					<div class="col-md-12">
						<p class="pull-right">
							<button class="btn_1 medium" @click="edita_titular()">Editar Titular</button>
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
</template>

<script>
import { ajax, tratamento_requisicao, alerta } from "@/utils/util";
import { toDate, toTimeStamp } from "@/utils/formater";
import funcoesGerais from "@/assets/js/funcoes.js";
import axios from 'axios'

export default {
  mixins: [funcoesGerais],
  data() {
	return {
		id_titular: this.$route.params.id_titular,
		lang: {
		days: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
	  months: [
		"Jan",
		"Fev",
		"Mar",
		"Abr",
		"Mai",
		"Jun",
		"Jul",
		"Ago",
		"Set",
		"Out",
		"Nov",
		"Dec"
	  ],
	  pickers: [
		"prox 7 dias",
		"prox 30 dias",
		"7 dias anteriores",
		"30 dias anteriores"
	  ],
		placeholder: {
		  date: "Selecione a data",
		  dateRange: "Selecione o intervalo"
		}
	  },
	  titular: [],
	  isLoading: false,
	};
	},
	
  mounted() {
	var self = this;
		var user = JSON.parse(localStorage.getItem("token_adm_comprodonto"));
		if (user) {
		self.isLoading = true;
		ajax("get", "/titulares/" + self.id_titular)
			.then(response => {
			self.isLoading = false;
			self.titular = response.data;
			self.titular.birth_date = toDate(self.titular.birth_date);
			})
			.catch(error => {
			self.isLoading = false;
			tratamento_requisicao(error, this);
			});
		} else {
			self.$router.replace(self.$route.query.redirect || "/");
		}
	},
  methods: {
		edita_titular() {
			let self = this;
			self.isLoading = true;
			self.titular.birth_date = toTimeStamp(self.titular.birth_date);
			ajax("put", `titulares/${self.id_titular}`, self.titular)
			.then(res => {
				self.isLoading = false;
				self.titular.birth_date = toDate(res.data.birth_date);
				alerta("success", "Sucesso", "Titular alterado com sucesso");
			})
			.catch(e => {
				self.isLoading = false;
				tratamento_requisicao(e);
			})
		}
  }
};
</script>
